import { create } from "zustand";
import produce from "immer";
import * as api from "../services/items";
import { arrayToByIdsAllIds } from "./utils";

export const ITEM_CHARACTERISTIC = Object.freeze({
  DIFFERENT: "different",
  SIMULAR: "simular",
  UNIQUE: "unique",
});

export const useItemStore = create((set) => ({
  byIds: {},
  allIds: [],
  total: 0,
  getById: async ({ id }) => {
    const one = await api.getById({ id });
    set(
      produce((draft) => {
        draft.byIds[one.data.id] = one.data;
        if (!draft.allIds.includes(one.data.id)) {
          draft.allIds.push(one.data.id);
        }
      }),
    );
  },
  fetchSome: async ({
    q = "",
    filter = "",
    limit = 20,
    offset = 0,
    sort_by = "number",
    sort_dir = "asc",
  }) => {
    const some = await api.getSome({
      q,
      filter,
      limit,
      offset,
      sort_by,
      sort_dir,
    });
    set(
      produce((draft) => {
        [draft.byIds, draft.allIds] = arrayToByIdsAllIds(some.data);
        draft.total = some.total;

        // TODO make pagination work if we keep all data
        //[draft.byIds, draft.allIds] = arrayToByIdsAllIds([...Object.values(draft.byIds), ...some.data]);
        //draft.total = some.total;
      }),
    );
  },

  createOne: async ({
    number,
    name,
    description,
    highlight,
    characteristic,
    inspect_every_x_months,
    group_ids,
  }) => {
    const one = await api.createOne({
      number,
      name,
      description,
      highlight,
      characteristic,
      inspect_every_x_months,
      group_ids,
    });
    if (!!one.data) {
      set(
        produce((draft) => {
          draft.byIds[one.data.id] = one.data;
          draft.allIds.unshift(one.data.id);
        }),
      );
    }
    return one;
  },

  updateOne: async ({
    id,
    number,
    name,
    description,
    highlight,
    characteristic,
    inspect_every_x_months,
    group_ids,
  }) => {
    const one = await api.updateOne({
      id,
      number,
      name,
      description,
      highlight,
      characteristic,
      inspect_every_x_months,
      group_ids,
    });
    if (!!one.data) {
      set(
        produce((draft) => {
          draft.byIds[one.data.id] = one.data;
        }),
      );
    }
    return one;
  },
}));
